import constants from '@/config/constants';
import { callApi } from '@/services/CallApi.service';

const admin = {
    getAdoptedList: async (accessToken) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/screen/list/adopted`,
            method: 'GET',
        };

        return await callApi(options, accessToken);
    },
    getAdoptedListInSite: async (accessToken, siteUid) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/screen/list/adopted/site/${siteUid}`,
            method: 'GET',
        };

        return await callApi(options, accessToken);
    },
    get: async (accessToken, screenUid) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/screen/${screenUid}`,
            method: 'GET',
        };

        return await callApi(options, accessToken);
    },
    pairNew: async (accessToken, formData) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/screen/pair/new`,
            method: 'PATCH',
        };

        const body = {
            new: formData.new,
            pairingCode: formData.pairingCode,
            name: formData.name,
            siteUid: formData.siteUid,
        };

        return await callApi(options, accessToken, body);
    },
    pairExisting: async (accessToken, formData, screenUid) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/screen/pair/existing/${screenUid}`,
            method: 'PATCH',
        };

        const body = {
            new: formData.new,
            pairingCode: formData.pairingCode,
        };

        return await callApi(options, accessToken, body);
    },
    update: async (accessToken, screenUid, formData) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/screen/${screenUid}`,
            method: 'PATCH',
        };

        const body = {
            name: formData.name,
            dateEnabled: formData.dateEnabled,
            timeEnabled: formData.timeEnabled,
            transition: formData.transition,
            layout: formData.layout,
        };

        return await callApi(options, accessToken, body);
    },
    remove: async (accessToken, screenUid) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/screen/${screenUid}`,
            method: 'DELETE',
        };

        return await callApi(options, accessToken);
    },
};

const getCountInOrg = async (accessToken) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/count`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const getAdoptedListInSite = async (accessToken, siteUid) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/list/site/${siteUid}`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const get = async (accessToken, screenUid) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/${screenUid}`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const getContentList = async (accessToken, screenUid) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/content/${screenUid}`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

const updateContentList = async (accessToken, screenUid, formData) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/content/${screenUid}`,
        method: 'PATCH',
    };

    const body = {
        contentList: formData.contentList,
    };

    return await callApi(options, accessToken, body);
};

const createScreenShareMeeting = async (accessToken, screenUids) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/screen-share/meeting/create`,
        method: 'POST',
    };

    const body = {
        screenUids: screenUids,
    };

    return await callApi(options, accessToken, body);
};

const endScreenShareMeeting = async (accessToken) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/screen-share/meeting/end`,
        method: 'DELETE',
    };

    return await callApi(options, accessToken,);
};

const updateAnnouncementEnabled = async (accessToken, screenUid, enabled) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/announcement/enabled/${screenUid}`,
        method: 'PATCH',
    };

    const body = {
        enabled,
    };

    return await callApi(options, accessToken, body);
};

/*
const updateDateEnabled = async (accessToken, screenUid, enabled) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/date/enabled/${screenUid}`,
        method: 'PATCH',
    };

    const body = {
        enabled,
    };

    return await callApi(options, accessToken, body);
};

const updateTimeEnabled = async (accessToken, screenUid, enabled) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/time/enabled/${screenUid}`,
        method: 'PATCH',
    };

    const body = {
        enabled,
    };

    return await callApi(options, accessToken, body);
};

const updateTransition = async (accessToken, screenUid, value) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/transition/${screenUid}`,
        method: 'PATCH',
    };

    const body = {
        value,
    };

    return await callApi(options, accessToken, body);
};
*/

const updateDuration = async (accessToken, screenUid, value) => {

    const options = {
        url: `${constants.api.baseUrl}/screen/properties/duration/${screenUid}`,
        method: 'PATCH',
    };

    const body = {
        value,
    };

    return await callApi(options, accessToken, body);
};

export default {
    admin,
    getCountInOrg,
    getAdoptedListInSite,
    get,
    getContentList,
    updateContentList,
    createScreenShareMeeting,   
    endScreenShareMeeting,
    updateAnnouncementEnabled,
    //updateDateEnabled,
    //updateTimeEnabled,
    //updateTransition,
    updateDuration,
};
